import * as React from 'react'
import { BPMChart } from '../../../../components/Chart'
import { BPMAnalyticsAPI } from '../../../../api'
import { CategoryGroupBy, typeToDisplay } from './GroupByHelper'
import { PlatformContext } from '../../../../components/context/platform'
import { sp } from '../../../../utils/platformSelect'

export const AlbumChart: React.FunctionComponent = (props) => {

    const platform = React.useContext(PlatformContext)
    const [type, setType] = React.useState<string>()
    const toolbarItems = CategoryGroupBy({ onTypeChange: setType })
    if (!type) {
        return null
    }
    return (
        <BPMChart {...props} title={`Number of ${sp(platform, { default: 'Albums', create: 'Sound Packs' })}`} subTitle={'By ' + typeToDisplay(type)} type='tree'
            onRequestLoad={(options, signal) => {
                return BPMAnalyticsAPI.get<any>('categories/byCol', options, signal)
            }} additionalParams={{ type: sp(platform, { default: 'album_id', create: 'sound_package_id' }), groupBy: type }} toolBarItems={() => toolbarItems}
            allowedTypes={['spline', 'bar', 'doughnut', 'pie', 'tree']}
            series={{
                name: `Number of ${sp(platform, { default: 'Albums', create: 'Sound Packs' })}`,
                valueField: 'count',
                argumentField: type,
                smallValuesGrouping: { topCount: 20, mode: 'topN' }
            }}>
        </BPMChart>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Statistics/Category/charts/AlbumChart.tsx